import { render, staticRenderFns } from "./bigDividendFinishList.vue?vue&type=template&id=53b2b6ab&"
import script from "./bigDividendFinishList.vue?vue&type=script&lang=js&"
export * from "./bigDividendFinishList.vue?vue&type=script&lang=js&"
import style0 from "./bigDividendFinishList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports